module.exports = __webpack_public_path__ + "static/img/ma2.524ed91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ma2.png
// module id = QeB7
// module chunks = 1